module.exports = __webpack_public_path__ + "static/media/payment-icon-visa.d09d0d78.svg";